<template>
  <div class="audio-content" v-loading="loading">
    <el-button
      type="primary"
      @click="openEditWin('create')"
      >添加</el-button
    >
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <el-table-column prop="terminal_number" label="终端编号">
      </el-table-column>
      <el-table-column prop="terminal_ip" label="终端地址">
        <template slot-scope="scope">
          <span v-if="scope.row.terminal_ip">{{ scope.row.terminal_ip }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="lamp_name" label="所属路灯"> </el-table-column>
      <el-table-column prop="volume" label="音量"> </el-table-column>
      <el-table-column prop="status" label="状态" sortable>
        <template slot-scope="scope">
          <i :class="stateIcon(scope.row.status)"></i>
          <span>{{ scope.row.status }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="date" label="时间">
        <template slot-scope="scope">
          <span v-if="scope.row.date">{{ scope.row.date }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="edit" label="编辑" width="100">
        <template slot-scope="scope">
          <div class="edit-button">
            <i
              @click="openEditWin(scope.row)"
              class="el-icon-edit pointer mar-r10"
            ></i>
            <i
              class="el-icon-delete pointer"
              @click="delItem(scope.row.id)"
            ></i>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageInfo.page"
      :page-sizes="[10, 20, 30, 40, 50, 100]"
      :page-size="pageInfo.pageSize"
      layout="sizes, total, prev, pager, next, jumper"
      :total="cnt_all"
    >
    </el-pagination>

    <!--新增对话框-->
    <el-dialog
      class="dialog600"
      :title="editType === 'create' ? '添加' : '修改'"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
    >
      <el-form
        :model="editOne"
        label-position="left"
        label-width="100px"
      >
        <div class="user-info">
          <el-form-item label="终端编号" prop="terminal_number">
            <el-input 
            v-model="editOne.terminal_number"
            :disabled="editType === 'create' ? false : true"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="终端IP" prop="terminal_ip">
            <el-input v-model="editOne.terminal_ip"></el-input>
          </el-form-item> -->

          <el-form-item label="初始音量" prop="volume" class="h28">
            <el-input-number v-model="editOne.volume" :min="1" :max="100"></el-input-number>
          </el-form-item>

          <el-form-item label="选择路灯">
            <el-select
              clearable
              filterable 
              placeholder="请选择所属路灯"
              v-model="editOne.lamp_id"
              style="width: 100%"
            >
              <el-option
                v-for="t in lampList"
                :key="t.lamp_id"
                :label="t.name"
                :value="t.lamp_id"
              ></el-option>
            </el-select>
          </el-form-item>

        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="mw-edit-button" @click="dialogVisible = false"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click="createItem"
          v-if="editType === 'create'"
          >确 定</el-button
        >
        <el-button
          type="primary"
          @click="updateItem"
          v-if="editType === 'update'"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import lightListApi from "@/api/light/lightList";
import autoListApi from "@/api/audio/audioList";
export default {
  data() {
    return {
      loading: false,
      tableData: [],
      pageInfo: {
        page: 1,
        pageSize: 20,
      },
      cnt_all: 0,
      dialogVisible: false,
      editType: -1,
      lampList: [],
      editOne: {
        terminal_number: '',
        // terminal_ip: '',
        lamp_id: '',
        volume: null
      }
    };
  },
  methods: {
    getTableData(pageIndex) {
      this.pageInfo.page = pageIndex;
      this.loading = true;
      autoListApi.audioList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          // console.log('tableData',resData)
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
          this.getLampList()
        }
      });
    },

    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },
    openEditWin(index) {
      if (index === "create") {
        this.editOne = {
          terminal_number: '',
          // terminal_ip: '',
          lamp_id: '',
          volume: null
        };
        this.editType = "create";
      } else {
        this.editOne = {
          id: index.id,
          terminal_number: index.terminal_number,
          // terminal_ip: index.terminal_ip,
          lamp_id: index.lamp_id,
          volume: index.volume
        };
        this.editType = "update";
      }
      this.dialogVisible = true;
    },

    updateItem() {
      autoListApi.audioEdit(this.editOne.id, this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("修改成功");
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    createItem() {
      autoListApi.audioAdd(this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("添加成功");
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    getLampList() { // 获取路灯列表
      lightListApi.lightList({
        page: 1,
        pageSize: 500,
      }).then((res) => {
        if (res.data.code === 1000) {
          let resData = res.data.data;
          this.lampList = resData.list;
        }
      });
    },
    delItem(id) {
      this.$confirm("本操作将永久删除该条信息，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          autoListApi.audioDel(id).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success("删除成功");
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    stateIcon(ste) {
      if (ste === "在线") {
        return "valuegreen";
      } else {
        return "valuered";
      }
    },
  },
  mounted() {
    this.getTableData(this.pageInfo.page);
  },
};
</script>
<style lang='less' scoped>
.audio-content {
  width: 100%;
}
</style>
<style>
.h28 .el-input__inner {
    height: 28px !important;
  line-height: 28px !important;
}
</style>